import { render } from "./IconAlertTriangleSolid.vue?vue&type=template&id=462d8f76"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconAlertTriangleSolid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "462d8f76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('462d8f76', __exports__)) {
    api.reload('462d8f76', __exports__)
  }
  
  module.hot.accept("./IconAlertTriangleSolid.vue?vue&type=template&id=462d8f76", () => {
    api.rerender('462d8f76', render)
  })

}


export default __exports__